
import styled from "styled-components";

const StyledCategoriesList = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;
`;

export default StyledCategoriesList;
